import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const DiceExpression = styled.div`
    color: #bbb;
    padding-bottom: 10px;
    font-size: 12px;
    color: #999;
`;

export const DiceResultValue = styled.div`
    width: 100%;
    flex-wrap: wrap;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
`;

export const DiceGroup = styled.div`
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const ResultValue = styled.div`
    font-size: 18px;
    font-weight: 900;
    color: #fff;
    position: relative;
    width: 40px;
    text-align: center;
    margin-left: 10px;
    opacity: 0;
    transition: all .4s ease 0s;

    :before {
        content: '=';
        width: 10px;
        text-align: center;
        position: absolute;
        top: calc(50% - 10px);
        left: -5px;
        height: 20px;
        line-height: 20px;
    }

    &.show {
        opacity: 1;
    }
`;
